import React from "react";
import { Modal, Form, Button, message, Popover, Space } from "antd";
import RichEditor from "@/components/display/richEditor";
import { addFirmware } from "@/fetch/fetchApi";
// import UploadGeneral from "@/components/display/upload/uploadGeneral";
import OssUpload from "@/components/display/upload/OssUpload";
import fetchHandler from "@/fetch/fetchHandler";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { reject } from "lodash";

const fileNameJsonParmas = {
  // company: undefined,
  // acDc: undefined,
  // cmosType: undefined,
  // frameType: undefined,
  // stubType: undefined,
  // date: undefined,
  // frameWork: undefined,
  // smallVersion: undefined,
  // updateCompay: undefined,
  // firmwareFileName: undefined,
};
class UploadModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      transKey: "",
    };
  }

  // 设置Form的ref
  formRef = React.createRef();

  handleSubmit = () => {
    const { validateFields } = this.formRef.current;
    this.setState({
      loading: true,
    });
    validateFields()
      .then((values) => {
        console.log("validateFields:", values);
        let flag = true;
        if (Object.keys(fileNameJsonParmas).length === 0) {
          flag = false;
        }
        if (!flag) {
          message.warning("文件格式不正确，请重新上传！");
          // reject();
          this.setState({
            loading: false,
          });
          return;
        }
        fetchHandler(addFirmware, {
          url: values.file[0].url,
          key: this.state.transKey,
          ...fileNameJsonParmas,
          // firmwareFileName: values.file[0].response.fileIdList[0],
          // userId: sessionStorage.getItem('name'),
          info: values.info,
        }).then((res) => {
          this.setState({
            loading: false,
          });
          if (res && res.code === "success") {
            message.success("固件版本上传成功");
            this.props.refresh();
            this.props.onCancel();
          }
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  // 修改版本富文本信息
  changeVersionInfo = (changeValue) => {
    // console.log("changeVersionInfo:", changeValue);
    const { setFieldsValue } = this.formRef.current;
    setFieldsValue({ info: changeValue });
  };

  handleUploadChange = (fileList) => {
    this.formRef.current.setFieldsValue({
      file: fileList,
    });
  };

  render() {
    return (
      <Modal
        width={800}
        title="上传版本"
        visible={this.props.visible}
        onCancel={this.props.onCancel}
        onOk={this.handleSubmit}
        okButtonProps={{
          loading: this.state.loading,
        }}>
        <Form labelCol={{ span: 3 }} wrapperCol={{ span: 21 }} ref={this.formRef}>
          <Form.Item
            label="选择文件"
            name="file"
            rules={[{ required: true, message: "请选择文件" }]}
            style={{ overflow: "inherit" }}>
            {/* <UploadGeneral
              uploadPath="/uploadFile.do"
              types={["bin"]}
              valueChange={this.handleUploadChange}
              uploadProps={{
                progress: {
                  strokeWidth: 3,
                  format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
                },
                data: (file) => {
                  const fileName = file.name;
                  const dataArr = fileName.split("_");
                  return {
                    storeName: "firmware_charing_upload",
                    filePath: `/${dataArr[3]}/${fileName}`,
                    frameType: dataArr[3],
                    frameWork: dataArr[6],
                  };
                },
                beforeUpload: (file) => {
                  const fileName = file.name;
                  const dataArr = fileName.split("_");
                  if (dataArr.length < 8) {
                    message.error("文件命名格式错误！");
                    file.status = "error";
                    return false;
                  } else {
                    fileNameJsonParmas["company"] = dataArr[0];
                    fileNameJsonParmas["acDc"] = dataArr[1];
                    fileNameJsonParmas["cmosType"] = dataArr[2];
                    fileNameJsonParmas["frameType"] = dataArr[3];
                    fileNameJsonParmas["stubType"] = dataArr[4];
                    fileNameJsonParmas["date"] = dataArr[5];
                    fileNameJsonParmas["frameWork"] = dataArr[6];
                    fileNameJsonParmas["updateCompay"] = dataArr[7].split(".")[0];
                    fileNameJsonParmas["firmwareFileName"] = fileName;

                    // props.data.filePath = "chargepoint/firmware/" + dataArr[3] + "/" + fileName;
                  }
                },
              }}
              cover>
              <Button type="primary">点击上传</Button>
            </UploadGeneral> */}
            <OssUpload
              getKey={(key) => {
                this.setState({
                  transKey: key,
                });
              }}
              bf={(file) => {
                const fileName = file.name;
                const dataArr = fileName.split("_");
                if (dataArr.length < 8) {
                  message.error("文件命名格式错误！");
                  file.status = "error";
                  return false;
                } else {
                  fileNameJsonParmas["company"] = dataArr[0];
                  fileNameJsonParmas["acDc"] = dataArr[1];
                  fileNameJsonParmas["cmosType"] = dataArr[2];
                  fileNameJsonParmas["frameType"] = dataArr[3];
                  fileNameJsonParmas["stubType"] = dataArr[4];
                  fileNameJsonParmas["date"] = dataArr[5];
                  // fileNameJsonParmas["frameWork"] = dataArr[6];
                  if (dataArr[6].indexOf("-") !== -1) {
                    fileNameJsonParmas["frameWork"] = dataArr[6].split("-")[0];
                    fileNameJsonParmas["smallVersion"] = dataArr[6].split("-")[1];
                  } else {
                    fileNameJsonParmas["frameWork"] = dataArr[6];
                    fileNameJsonParmas["smallVersion"] = "";
                  }
                  fileNameJsonParmas["updateCompay"] = dataArr[7].split(".")[0];
                  fileNameJsonParmas["firmwareFileName"] = fileName;

                  // props.data.filePath = "chargepoint/firmware/" + dataArr[3] + "/" + fileName;
                }
              }}>
              <Button type="primary">点击上传</Button>
              <Popover
                content={
                  <div>
                    <div>升级包命名(流)</div>
                    <div>
                      <span>DH_AC\DC_LPC1778\LPC824_ CUSTOMNUMBER _SMC_DATA_VERSIONNUMBER</span>
                      <span>_DH.BIN</span>
                    </div>
                    <br />
                    <div>拆解：</div>
                    <div> DH 德和科技</div>
                    <div> AC\DC 交流直流充电桩</div>
                    <div> LPC1778\LPC824 芯片型号，后续可以有改动用了新的型号</div>
                    <div> CUSTOMNUMBER 客户编号，可以根据客户公司信息等制定的一个专用编号</div>
                    <div> SMC 充电桩款型，根据款型不同更改，有SMC钣金等</div>
                    <div> DATA日期，包括年月日 如150820表示2015年8月20号</div>
                    <div>
                      <span>VERSIONNUMBER 需要升级的软件的软件版本号，小版本使用破折号分割，</span>
                      <span>上传小版本命名规范：XX-XX，上传大版本命名规范：XX</span>
                    </div>
                    <div> DH 默认</div>
                    <div> BIN 升级文件的后缀名</div>
                  </div>
                }>
                <QuestionCircleOutlined style={{ marginLeft: 12 }} />
              </Popover>
            </OssUpload>
          </Form.Item>
          <Form.Item
            label="版本说明"
            name="info"
            style={{ overflow: "inherit" }}
            rules={[
              { required: true, min: 20, message: "请输入不少于20个字数的版本说明" },
              // { min: 25, message: "请输入不少于20个字数的版本说明" },
            ]}>
            <RichEditor
              onChange={(changedValue) => {
                this.changeVersionInfo(changedValue);
              }}
              className="upload-version-class"
              ref={(ref) => (this.editRef = ref)}
              controls={[
                "undo",
                "redo",
                "separator",
                "font-size",
                "line-height",
                "letter-spacing",
                "separator",
                "bold",
                "text-color",
                // "media",
                // 'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
                // 'superscript', 'subscript', 'remove-styles', 'emoji', 'separator',
                // 'text-indent', 'text-align', 'separator',
                // 'headings', 'list-ul', 'list-ol', 'blockquote', 'code', 'separator',
                "link",
                "separator",
                "hr",
                "separator",
                // 'separator',
                // 'clear'
              ]}
            />
            {/* <Input.TextArea placeholder="字数不少于20字"></Input.TextArea> */}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default UploadModal;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/firmwareVersionManage/uploadModal.js